import React, { useState } from "react";
import styled from "styled-components";
import ThemeSchema from "../../../../theme/schema";
import { useUser } from "../../../../context/User.context";

const ActionLegendParagraph = styled.p`
  color: ${({ theme }) => theme.colors["foreground-color"]};
  min-width: 120px;
  white-space: nowrap;
`;

const ActionV3LegendContainer = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
`;

interface ActionV3LegendProps {
  onClick?: Function;
  filterStatus?: boolean;
  liStyles?: Object;
}

function ActionV3Legend(props: ActionV3LegendProps) {
  const { onClick, filterStatus, liStyles } = props;
  const [selectedAction, setSelectedAction] = useState<string>("");

  const { user } = useUser();
  const theme = user?.settings?.theme;

  const colorScheme = [
    {
      color:
        ThemeSchema.data[theme ?? "dark"]?.colors[
          "progress_bar-pending_approval"
        ],
      label: "Pending Approval Devices",
    },
    {
      color:
        ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-scheduled"],
      label: "Scheduled Devices",
    },
    {
      color: ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-queued"],
      label: "Queued Devices",
    },
    {
      color:
        ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-initiated"],
      label: "Initiated Devices",
    },
    {
      color:
        ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-in_progress"],
      label: "In Progress Devices",
    },
    {
      color:
        ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-completed"],
      label: "Completed Devices",
    },
    {
      color: ThemeSchema.data[theme ?? "dark"]?.colors["progress_bar-failed"],
      label: "Failed Devices",
    },
  ];

  return (
    <ActionV3LegendContainer>
      {colorScheme.map((item) => (
        <li
          key={item.label}
          style={{
            display: "flex",
            alignItems: "center",
            ...liStyles,
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              background: item.color,
              marginRight: "0.5rem",
            }}
          />

          <ActionLegendParagraph
            className={`${
              selectedAction === item.label && filterStatus && "underline bold"
            }`}
            onClick={() => {
              if (onClick) {
                onClick(item.label);
                setSelectedAction(item.label);
              }
            }}
          >
            {item.label}
          </ActionLegendParagraph>
        </li>
      ))}
    </ActionV3LegendContainer>
  );
}

export default ActionV3Legend;
